import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';

import {
  HeaderFavorites,
  HeaderLogo,
  HeaderNavDesktop,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

import styles from './withOneLineContentNavLeft.module.scss';

const HeaderWithOneLineContentNavLeftDesktop = () => (
  <HeaderRow borderless className={styles.header_row} type="medium">
    <HeaderSection justify="start">
      <HeaderLogo fullWidth />
    </HeaderSection>
    <HeaderSection className={styles.nav_section} justify="start">
      <HeaderNavDesktop />
    </HeaderSection>
    <HeaderSection justify="end">
      <StoreLocator />
      <MedRecSwitch />
      <SearchHeader withEmbeddedInput />
      <HeaderProfile />
      <HeaderFavorites />
      <HeaderShopping />
    </HeaderSection>
  </HeaderRow>
);

export { HeaderWithOneLineContentNavLeftDesktop };
